import request from '@/utils/request'

// 获取财务记录列表：get finance/findRecordList, // 参数：
// page
// size
// title // ONLINE:线上收款，ONLINE_REFUND:线上退款
// keyword // 订单号/备注
// orderTypehood // 订单类型
// startDate // 开始日期，YYYY-MM-DD
// endDate // 结束日期 YYYY-MM-DD
export function findRecordList(params) {
  return request({
    url: '/finance/findRecordList',
    method: 'get',
    params,
  })
}

// 获取单条财务记录：get finance/findRecord，参数：
// recordId // 记录ID
export function findRecord(params) {
  return request({
    url: '/finance/findRecord',
    method: 'get',
    params,
  })
}
